import { Heart } from 'lucide-react';
import { useTheme } from '@elka/theme';

export interface FooterProps {
  /** App title to display in the footer (e.g., "CRM", "פורטל עובדים", "מערכת ניהול פרויקטים") */
  appTitle: string;
  /** Version string from package.json */
  version: string;
  /** Hide footer on mobile (e.g. when using BottomTabBar) */
  hideOnMobile?: boolean;
}

export function Footer({ appTitle, version, hideOnMobile = false }: FooterProps) {
  const currentYear = new Date().getFullYear();
  const { colors } = useTheme();

  return (
    <footer
      className={`relative bg-gradient-to-r ${colors.headerBg} mt-auto overflow-hidden border-t border-white/10 ${hideOnMobile ? 'hidden md:block' : ''}`}
    >
      {/* Subtle background glow */}
      <div className="absolute inset-0 overflow-hidden">
        <div
          className={`absolute -bottom-12 left-1/4 h-64 w-64 ${colors.headerGlow1} rounded-full opacity-15 mix-blend-multiply blur-3xl filter`}
        ></div>
        <div
          className={`absolute right-1/4 -bottom-12 h-64 w-64 ${colors.headerGlow2} rounded-full opacity-15 mix-blend-multiply blur-3xl filter`}
        ></div>
        <div
          className={`absolute -bottom-12 left-1/2 h-48 w-48 ${colors.headerGlow3} rounded-full opacity-10 mix-blend-multiply blur-3xl filter`}
        ></div>
      </div>

      <div className="relative mx-auto max-w-7xl px-4 py-5 md:px-6 md:py-6">
        {/* Desktop: Horizontal Layout */}
        <div className="flex flex-col items-center justify-between gap-4 md:flex-row md:gap-0">
          {/* Left side - Copyright */}
          <div className={`flex items-center gap-2 text-sm ${colors.footerTextLight}`}>
            <span>© {currentYear}</span>
            <span
              className={`bg-gradient-to-r bg-clip-text text-transparent ${colors.titleGradient} font-semibold`}
            >
              {appTitle}
            </span>
            <span>מבית אלקה מערכות ניהול</span>
            <span className="hidden md:inline">|</span>
            <span className="hidden items-center gap-1 md:flex">
              נבנה עם
              <Heart className="text-red-400" size={14} fill="currentColor" />
              בישראל
            </span>
          </div>

          {/* Right side - Version */}
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2 rounded-lg border border-white/20 bg-slate-800/50 px-4 py-2 backdrop-blur-xl">
              <span className={`text-sm ${colors.footerTextLight} font-mono font-semibold`}>
                v{version}
              </span>
              <span className="h-2 w-2 animate-pulse rounded-full bg-emerald-400"></span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
